import React from 'react';
import { WordItem } from '../types';
import { UnifiedQuizChallengeModal } from './UnifiedQuizChallengeModal';

interface FavoriteChallengeViewProps {
  favoriteWords: WordItem[];
  allWords: WordItem[];
  onClose: () => void;
  onAddScore?: (xp: number) => void;
}

export const FavoriteChallengeView: React.FC<FavoriteChallengeViewProps> = ({
  favoriteWords,
  allWords,
  onClose,
  onAddScore,
}) => {
  return (
    <UnifiedQuizChallengeModal
      title="Quizz • Mes Mots Favoris"
      subtitle="Entraînez-vous sur votre sélection personnelle"
      icon="❤️"
      words={favoriteWords}
      allWords={allWords}
      onClose={onClose}
      onAddScore={onAddScore}
      initialHearts={5}
    />
  );
};
